import { gql, useMutation } from '@apollo/client';

import { GET_CURRENT_SUBSCRIPTION } from 'src/hooks/subscriptions/get-current-subscription.hook';

import { GET_PUBLIC_EMPLOYEES_FOR_TABLE } from './get-public-employees.hook';

export const CHANGE_EMPLOYEE_STATUS = gql`
  mutation updateEmployeePersonalInfoStatus($payload: UpdateEmployeePersonalInfoStatusInput!) {
    updateEmployeePersonalInfoStatus(payload: $payload) {
      _id
    }
  }
`;

export const useChangeEmployeeStatus = () => {
  const [changeEmployeeStatus] = useMutation(CHANGE_EMPLOYEE_STATUS, {
    refetchQueries: [GET_PUBLIC_EMPLOYEES_FOR_TABLE, GET_CURRENT_SUBSCRIPTION],
  });

  return changeEmployeeStatus;
};
